
import Vue from 'vue';
import BravadoText from '~/components/common/BravadoText/BravadoText.vue';
import DealStoryBadge from '~/components/partials/war-room/WarRoomDeal/DealStoryBadge.vue';
import WarRoomDealStoryHeaderFormatter from '~/components/partials/war-room/WarRoomDeal/WarRoomDealStoryHeaderFormatter.vue';

export default Vue.extend({
  name: 'WarRoomDealStoryPostHeader',
  components: {
    WarRoomDealStoryHeaderFormatter,
    BravadoText,
    DealStoryBadge,
  },
  props: {
    author: {
      type: String,
      required: true,
    },
    company: {
      type: String,
      default: 'a deal',
    },
    amount: {
      type: Number,
      required: true,
    },
    departments: {
      type: Array,
      default: () => [],
    },
  },
});
